// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HeaderBackButton_wrapper__3ixdD","navigationBack":"HeaderBackButton_navigationBack__2cNxu","textWrapper":"HeaderBackButton_textWrapper__2uqtN"};